import type { RedirectRequest } from '@azure/msal-browser'

/**
 * Uses persisted `session.forceMsalPromptNextLogin` (redux-persist) via the `forcePrompt` flag.
 */
export function buildMsalRedirectRequest(
  forceMsalPromptNextLogin: boolean,
  scopes: string[]
): RedirectRequest {
  if (forceMsalPromptNextLogin) {
    return { scopes, prompt: 'login' }
  }
  return { scopes }
}
